/*jshint esversion: 8 */
import store from '../components/stores/Store';
import { toJS } from "mobx";

const isMobile = async (str) => {
  return /^1[3-9]\d{9}$/.test(str);
};


const getPasswordStrength = async (str) => {
  let strLv = 0;
  if (/[0-9]/.test(str)) strLv = strLv + 1;
  if (/[a-z]/.test(str)) strLv = strLv + 1;
  if (/[A-Z]/.test(str)) strLv = strLv + 1;
  if (/[^0-9a-zA-Z]/.test(str)) strLv = strLv + 1;
  if (str.length < 6) strLv = 0;
  return strLv;
};



const checkAuth = (ipath) => {
  // return true;
  const auth = toJS(store.user.authSettings);
  console.log(`----- auth: `, auth);
  const ipaths = ipath.split('-');
  console.log(`---- checkAuth - len ${ipaths.length}, ipaths:`, ipaths);
  let iauth = false;
  let isVisible = '';

  try {
    if (ipaths.length === 1) {
      if (!auth[ipaths[0]]) return false;
      iauth = auth[ipaths[0]][0];
      console.log(`----- iauth: `, iauth);
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L1: `, isVisible);
      return isVisible;
    }
    if (ipaths.length === 2) {
      if (!auth[ipaths[0]] ||
        !auth[ipaths[0]][1] ||
        !auth[ipaths[0]][1][ipaths[1]]) return false;
      iauth = auth[ipaths[0]][0];
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L1: `, isVisible);
      if (!isVisible) return isVisible;

      iauth = auth[ipaths[0]][1][ipaths[1]][0];
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L2: `, isVisible);
      return isVisible;
    }

    if (ipaths.length === 3) {
      if (!auth[ipaths[0]] ||
        !auth[ipaths[0]][1] ||
        !auth[ipaths[0]][1][ipaths[1]] ||
        !auth[ipaths[0]][1][ipaths[1]][1] ||
        !auth[ipaths[0]][1][ipaths[1]][1][ipaths[2]]) return false;
      iauth = auth[ipaths[0]][0];
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L1: `, isVisible);
      if (!isVisible) return isVisible;

      iauth = auth[ipaths[0]][1][ipaths[1]][0];
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L2: `, isVisible);
      if (!isVisible) return isVisible;

      iauth = auth[ipaths[0]][1][ipaths[1]][1][ipaths[2]][0];
      isVisible = ([1, '1', true, 'true'].includes(iauth));
      console.log(`----- iautisVisibleh-L3: `, isVisible);
      return isVisible;
    }
  } catch (error) {
    console.log(`-----error ${ipaths}:  `, error);
  }
};

const getIfFuncAuthorized = (ipath) => {
  try {
    // return true;
    const auth = toJS(store.user.authSettings);
    let iauth;
    // console.log(`----- getIfFuncAuthorized-ipath: `, ipath);
    const ipaths = ipath.split('-');
    if (ipaths.length === 1) {
      // console.log(`----- auth[ipaths[0]: `, auth[ipaths[0]]);
      if (!auth[ipaths[0]]) return false;
      return auth[ipaths[0]][0];
    } else if (ipaths.length === 2) {
      if (!auth[ipaths[0]] ||
        !auth[ipaths[0]][1] ||
        !auth[ipaths[0]][1][ipaths[1]]) return false;

      iauth = auth[ipaths[0]][0];
      if (!([1, '1', true, 'true'].includes(iauth))) return false;

      return auth[ipaths[0]][1][ipaths[1]][0];

    } else if (ipaths.length === 3) {
      if (!auth[ipaths[0]] ||
        !auth[ipaths[0]][1] ||
        !auth[ipaths[0]][1][ipaths[1]] ||
        !auth[ipaths[0]][1][ipaths[1]][1] ||
        !auth[ipaths[0]][1][ipaths[1]][1][ipaths[2]]) return false;

      iauth = auth[ipaths[0]][0];
      if (!([1, '1', true, 'true'].includes(iauth))) return false;

      iauth = auth[ipaths[0]][1][ipaths[1]][0];
      if (!([1, '1', true, 'true'].includes(iauth))) return false;

      return auth[ipaths[0]][1][ipaths[1]][1][ipaths[2]][0];
    }
  } catch (error) {
    console.log(`----- error in getIfFuncAuthorized: `, error);
    console.log(`----- error in getIfFuncAuthorized-ipath: `, ipath);
  }
};

export {
  isMobile,
  getPasswordStrength,
  checkAuth,
  getIfFuncAuthorized,
};
